import { render, staticRenderFns } from "./madeRequestsTable.vue?vue&type=template&id=b96785c8"
import script from "./madeRequestsTable.vue?vue&type=script&lang=js"
export * from "./madeRequestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports